import { Navigate, createFileRoute, useParams } from '@tanstack/react-router';

import { CreateAsset } from '@/features/AssetCollection/CreateAsset/CreateAsset';
import { useEditAssetRouteGuard } from '@/features/AssetCollection/CreateAsset/useEditAssetRouteGuard';

function EditAssetRoute() {
    const { assetId, projectId } = useParams({ strict: false }) as {
        assetId: string;
        projectId: string;
    };
    const { redirectTo } = useEditAssetRouteGuard({ assetId, projectId });

    if (redirectTo) {
        return <Navigate to={redirectTo.to} params={redirectTo.params} />;
    }

    return <CreateAsset />;
}

export const Route = createFileRoute(
    '/asset_collection/assets/$assetId/projects/$projectId/edit-asset',
)({
    component: EditAssetRoute,
});
